module.exports = __webpack_public_path__ + "static/media/t5.5261a1f8.png";